module.exports = __webpack_public_path__ + "static/media/truck-couch.dead977b.svg";